import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase/firebase';

const FIREBASE_COLLECTION = 'global-data';
const DOC_ID = 'q5lPpC1u4tlBij8siO1Q';

export async function fetchGlobalData() {
    const docRef = doc(db, FIREBASE_COLLECTION, DOC_ID);
    const snapshot = await getDoc(docRef);
    if (snapshot.exists()) {
        return snapshot.data();
    }
    console.log('No such document: globalData');
    return {};
}
